import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store/index'
import './index.css'
import App from './App'
import { LANG_DE } from '@config/constants'
/* global process */

const rootElm = document.getElementById('sujet-frontend-app')
window.SUJET_TEST_INITIALIZED = false

window.initSujetApp = () => {
  if (!window.SUJET_TEST_INITIALIZED && rootElm) {
    const root = ReactDOM.createRoot(rootElm)

    const lang = rootElm.getAttribute('data-lang') || LANG_DE

    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App lang={lang} />
        </Provider>
      </React.StrictMode>
    )

    window.SUJET_TEST_INITIALIZED = true
  }
}

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  window.initSujetApp()
}
